angular.module('unergie.main')
.factory('StoreService', () => {
    const createStore = function (dispatch) {
        const watchers = []
        let state = null

        const getState = () => state

        const connect = function (callback) {
            const callbackId = watchers.length
            watchers[callbackId] = callback
            const unsubscribe = () => (watchers[callbackId] = function () {})
            return unsubscribe
        }

        // Naive implementation of ng-redux + redux + redux-thunk + redux-devtools-extension due to stack constraint (need ES6 import/export)
        const onDispatch = function (action) {
            // Execute async function (equivalent to redux-thunk)
            if (typeof action === 'function') {
                action(onDispatch, getState)
                return
            }

            // Dispatch state
            state = dispatch(state, action)

            // Notify watcher
            return watchers.forEach((callback) => callback(state, action))
        }

        return { getState, connect, onDispatch }
    }

    return {
        createStore,
    }
})
